import { render, staticRenderFns } from "./SearchTab.vue?vue&type=template&id=0b46b093"
import script from "./SearchTab.vue?vue&type=script&lang=js"
export * from "./SearchTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports